import InfoBanner from '../Common/info-banner';
import styles from './index.module.scss';
import OverviewCard from './overview-card';

const MspOverview = () => {
  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <InfoBanner message={`This MSP has exceeded their license limit for Plan 1 (max 100 clients).\nPlease contact them to arrange a plan upgrade within 30 days — otherwise, their account will be suspended.`} />
        <OverviewCard />
      </div>
    </div>
  );
};

export default MspOverview;
